export default "//uniclient-edge-assets.lmndstaging.com/maya-avatar-22187b506cc7f3675a7c4341bb38d403.png"